import React from 'react'
import { PDFDownloadLink } from '@react-pdf/renderer'

import { MessagesPdfDoc } from './messages-pdf-doc'
import { Button, Icon } from '@chakra-ui/react'
import { FiDownload } from 'react-icons/fi'
import {
    ChatFieldsFragment,
    ChatMessageFieldsFragment,
} from '~graphql/generated/graphql'

export const ExportPDFButton: React.FC<{
    chat: ChatFieldsFragment
    documentTitle: string
    messages: ChatMessageFieldsFragment[]
    loading?: boolean
}> = ({ chat, documentTitle, messages, loading: loadingOverride }) => {
    const document = (
        <MessagesPdfDoc documentTitle={documentTitle} messages={messages} />
    )

    return (
        <PDFDownloadLink
            document={document}
            fileName={chat.clinic?.name + ' - ' + documentTitle}
        >
            {/* @ts-ignore */}
            {({ url, loading }) => (
                <Button
                    colorScheme="purple"
                    size="sm"
                    leftIcon={<Icon as={FiDownload} />}
                    isLoading={loading}
                    loadingText="Loading..."
                    onClick={() =>
                        url ? window.open(url, '_blank') : alert('Error!')
                    }
                >
                    Download PDF
                </Button>
            )}
        </PDFDownloadLink>
    )
}
